var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJliLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 819.9,
    height: 426.86,
    viewBox: "0 0 819.9 426.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ec6f20;\n      }\n\n      .cls-2 {\n        fill: #1a1a1a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.7,222.36v-10.05h70.81v6.46c0,19.53,11.53,32.11,28.97,32.11s28.13-12.37,28.13-32.11V54.68h70.81v167.69c0,55.3-39.81,93.94-98.95,93.94S5.7,277.81,5.7,222.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.44,245.47v64.38h-162.04V54.68h71.23v190.8h90.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.96,54.68h71.23v255.17h-71.23V54.68Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 564.72,
    y: 54.68,
    width: 255.17,
    height: 255.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJliLogoDark);
export default __webpack_public_path__ + "static/media/jli-logo-dark.7418c7364c0e645b93158a20d5dc2d7f.svg";
export { ForwardRef as ReactComponent };